/* istanbul ignore file */
// Generated code for Big.Webservice.Controllers.CorrespondenceController.
// Edit _ApiService.tst to change the generated output.
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ZorroApiClient } from '../zorro-api-client';

import { GetCorrespondenceResponse } from '../models/get-correspondence-response';

@Injectable()
export class CorrespondenceApiService extends ZorroApiClient {

    constructor(
      private readonly httpClient: HttpClient
    ) {
        super();
    }

    public getCorrespondenceData(spinnerMessage: string = null): Observable<GetCorrespondenceResponse> {
        return this.httpClient.get<GetCorrespondenceResponse>(`/api/correspondence`,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }


}
